import { Injectable } from '@angular/core';
import { BaseService } from '@shared/services/base.service';
import { UserRole } from '@map/models';

@Injectable({
    providedIn: 'root',
})
export class RoleService extends BaseService {
    constructor() {
        super();
        this.setApiName('Roles');
    }
    override mapResponseToObject<T>(response: any): T {
        return new UserRole(response) as any;
    }
    override mapArrayResponseToObject<T>(response: any): T {
        return response.map((responseJson: any) => new UserRole(responseJson));
    }
}
